
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveaway-picker",
      function () {
        return require("private-next-pages/giveaway-picker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveaway-picker"])
      });
    }
  